import { Component } from "@angular/core";

import { SvgMixinLargeComponent } from "../svg-large-mixin.component";

@Component({
  selector: "med-icon-ratings",
  templateUrl: "./med-icon-ratings.component.html",
})
export class MedIconRatingsComponent extends SvgMixinLargeComponent { }
